import React from 'react';

const AuthFailed = React.lazy(() => import('src/shared_modules/veu-visitors-plazz/components/auth/failed'));
const AuthHandler = React.lazy(() => import('src/shared_modules/veu-visitors-plazz/components/auth/handler'));

const ROUTE_PLAZZ = {
    component: React.Fragment,
    path: "/:event/plazz",
    exact: false,
};

const ROUTE_AUTH_FAILED = {
    component: AuthFailed,
    path: "/:event/auth/failed",
    exact: false,
};

const ROUTE_AUTH_HANDLER = {
    component: AuthHandler,
    path: "/:event/auth/:providermethod",
    exact: false,
};


const APP_PLAZZ_ROUTES = [
    ROUTE_PLAZZ,
    ROUTE_AUTH_FAILED,
    ROUTE_AUTH_HANDLER,
];

/*
* ---------------------------------------------------------------------
* Export
* ---------------------------------------------------------------------
*/
export default APP_PLAZZ_ROUTES;
